import { runListenersForEvent } from 'core_main/globals/events';
import { ON_CUSTOMER_DELETE_EVENT_TYPE } from 'core/constants';

export const handleCustomerDeletedEvent = () => {
  runListenersForEvent(ON_CUSTOMER_DELETE_EVENT_TYPE);
};
